import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CatalogService from "../services/catalog.service";
import OrderService from "../services/order.service";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AnimateHeight from "react-animate-height";
import ChooseAddress from "./ChooseAddress";

import { selectCurrentNewHireKitItems, getNewHireKitItems, selectDecorations, selectInventory } from '../reducers/catalog';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, ResponsiveEmbed } from 'react-bootstrap';
import NewHireKitItem from "./KitItem";
import ConfirmKitModal from "./modals/ConfirmKitModal";
import { currentOrder } from "../reducers/cart";
import { addKitToOrder, submitError } from "../reducers/cart";
import KitItem from "./KitItem";
import { toggleShowCart } from "../reducers/cart";

const KitHome = () => {
    const dispatch = useDispatch();
    const catalogItem = useSelector(selectCurrentNewHireKitItems);
    const [productList, setProductList] = useState([]);
    const inventory = useSelector(selectInventory);
    const itemStatus = useSelector(state => state.catalog.adminItemStatus)
    const [currentSize, setCurrentSize] = useState(null);
    const [allSelectedSizes, setAllSelectedSizes] = useState();
    const [height, setHeight] = useState(0);
    const [newAddress, setNewAddress] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [addKitErrorMessage, setAddKitErrorMessage] = useState(null);
    const [savingOrder, setSavingOrder] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [orderItems, setOrderItems] = useState([]);
    const [polybagChecked, setPolybagChecked] = useState(false);
    const [polybagLabel, setPolybagLabel] = useState("");
    const [isMale, setIsMale] = useState(true);
    const addKitSubmitError = useSelector(submitError);
    const [content, setContent] = useState('');

    const location = useLocation();
    let navigate = useNavigate();

    const gotoLogin = () => {
        navigate("/login");
    }



    const formatPantsSize = (sizeName) => {
        var isFour = /^\d{4}$/.test(sizeName);
        if (isFour) {
            return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
        } else {
            return sizeName;
        }
    }

    const sizeClick = (event) => {
        setCurrentSize(event.target.getAttribute("data"));
        setErrorMessage(null);
    }

    useEffect(() => {
        console.log("LOCATION CHANGED", location.key);
        dispatch(getNewHireKitItems(isMale));
        //setSelectedSizes([]);
    }, [location.key]);

    useEffect(() => {
        console.log("IS MALE CHANGED", isMale);
        dispatch(getNewHireKitItems(isMale));
        //setSelectedSizes([]);
    }, [location.key]);

    useEffect(() => {
        if (addKitSubmitError && addKitSubmitError != "") {
            console.log("ADD KIT ERROR MESSAGE", addKitSubmitError);
            setAddKitErrorMessage(addKitSubmitError);
            dispatch(toggleShowCart(false));
        }
    }, [addKitSubmitError]);



    useEffect(() => {
        console.log("IN USE EFFECT", itemStatus);
        var newContent = "";
        if (itemStatus === 'idle') {
            dispatch(getNewHireKitItems(isMale));
            newContent = <Spinner text="Loading..." />
        } else if (itemStatus === 'succeeded') {
            if (catalogItem && catalogItem.items && catalogItem.items.length > 0) {
                console.log("ITEMS", catalogItem);

                let newProductList = [];
                for (var i = 0; i < catalogItem.items.length; i++) {
                    let found = false;
                    for (var j = 0; j < newProductList.length; j++) {
                        if (newProductList[j][0].styleId === catalogItem.items[i].styleId) {
                            newProductList[j].push(catalogItem.items[i]);
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        newProductList.push([catalogItem.items[i]]);
                    }
                }
                setProductList(newProductList);

            }

        } else if (itemStatus === 'failed') {
            newContent = <div>error</div>
        }

    }, [itemStatus, dispatch]);

    const setSize = (itemIdx, productId) => {
        console.log("SET SIZE", itemIdx, productId, allSelectedSizes);
        let newSelectedSizes = [];
        if (!allSelectedSizes) {
            newSelectedSizes = new Array(productList.length);
        } else {
            for (var i = 0; i < productList.length; i++) {
                newSelectedSizes[i] = allSelectedSizes[i];
            }
        }

        if (productId == "" || productId == null) {
            newSelectedSizes[itemIdx] = null;
        } else {
            newSelectedSizes[itemIdx] = productId;
        }

        setAllSelectedSizes([...newSelectedSizes]);
        console.log("After SET SIZE", itemIdx, productId, newSelectedSizes, allSelectedSizes);
    }

    let price = 0;

    const closeAddressForm = (value) => {
        setHeight(0);
        setIsExpanded(false);
    }

    const setAddress = (address) => {
        console.log("SET ADDRESS", address);
        setNewAddress(address);
        setIsExpanded(false);
    }

    const toggleExpansion = () => {
        console.log("TOGGLE EXPANSION", isExpanded);
        var expanded = isExpanded;
        setIsExpanded(!isExpanded);
        setHeight(expanded ? 0 : 'auto');
    };


    const submitKit = async () => {
        setSavingOrder(true);
        var newOrderItems = [];
        console.log("SUBMITTING NEW HIRE KIT", allSelectedSizes);
        var error = false;
        var errorMessage = "";
        console.log("PRODUCT LIST", productList.length, allSelectedSizes.length, allSelectedSizes);
        if (allSelectedSizes == null || allSelectedSizes.length == 0 || allSelectedSizes.length != productList.length) {
            errorMessage = "Please select a size for all items. ";
            error = true;
        }
        for (var j = 0; j < allSelectedSizes.length; j++) {
            if (allSelectedSizes[j] == null) {
                errorMessage = "Please select a size for all items. ";
                error = true;
                break;
            }
        }

        if (error) {
            setErrorMessage(errorMessage);
            setSavingOrder(false);
            return;
        }

        console.log("ADDING ITEMS");

        for (var j = 0; j < allSelectedSizes.length; j++) {
            var selectedSizeProductId = allSelectedSizes[j];
            console.log("SELECTED SIZE PRODUCT ID", productList[j]);
            var selectedCatalogItem = null;
            for (var i = 0; i < catalogItem.items.length; i++) {
                if (catalogItem.items[i].sizes.find(size => size.productId == selectedSizeProductId)) {
                    selectedCatalogItem = catalogItem.items[i];
                    break;
                }
            }
            var item = { productId: selectedSizeProductId, decorations: selectedCatalogItem.logos, item: selectedCatalogItem };
            console.log("ADDING ITEM", item);
            newOrderItems.push(item);
        }

        setOrderItems(newOrderItems);
        dispatch(addKitToOrder(newOrderItems));
        dispatch(toggleShowCart(true));

    }

    const confirm = async () => {
        await OrderService.orderNewHireKit(orderItems, newAddress, polybagChecked, polybagLabel);
        setShowConfirmation(false);
        setSavingOrder(false);
        setNewAddress(null);
        //setSelectedSizes([]);
        navigate("/admin/newhirekits");
    }
    const closeAddressModal = async (update, newAddress) => {
        toggleExpansion();
        if (update) {
            await setNewAddress(newAddress);
            setErrorMessage(null);
        }
    }

    return (
        <Container>
            <h2>{isMale ? "Male" : "Female"} Kit Order <Button onClick={() => { dispatch(getNewHireKitItems(!isMale)); setIsMale(!isMale); }}>Switch to {isMale ? "Female" : "Male"}</Button></h2>
            <Container>
                {productList.map((products, i) => (
                    <><KitItem sizeIdx={i} products={products} inventory={inventory} setSize={setSize} edit={true} clearErrors={() => setErrorMessage(null)} />
                    </>
                ))}
            </Container>
            <Button onClick={submitKit} variant="primary" style={{ marginTop: 20 }}>
                Add Kit to Cart
            </Button>
            {(errorMessage || addKitErrorMessage) && <div className="error">{errorMessage ? errorMessage : ""} {addKitErrorMessage ? addKitErrorMessage : ""}</div>}
            {showConfirmation && orderItems && <ConfirmKitModal show={showConfirmation} close={() => setShowConfirmation(false)} confirm={confirm} items={orderItems} address={newAddress} polybagChecked={polybagChecked} polybagLabel={polybagLabel} />}
        </Container >
    );
};
export default KitHome;